import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useSelector } from "react-redux";

// provider, signer and the wallet SDK instance are not serializable, so they live here instead of the redux store
const EMPTY_SESSION = { provider: null, signer: null, instance: null };

const WalletSessionContext = createContext({
  ...EMPTY_SESSION,
  setSession: () => {},
  clearSession: () => {},
});

export const WalletSessionProvider = ({ children }) => {
  const [session, setSessionState] = useState(EMPTY_SESSION);
  const setSession = useCallback(({ provider = null, signer = null, instance = null }) => {
    setSessionState({ provider, signer, instance });
  }, []);
  const clearSession = useCallback(() => setSessionState(EMPTY_SESSION), []);
  const value = useMemo(() => ({ ...session, setSession, clearSession }), [session, setSession, clearSession]);
  return <WalletSessionContext.Provider value={value}>{children}</WalletSessionContext.Provider>;
};

export const useWalletSession = () => useContext(WalletSessionContext);

/**
 * Wallet state with the same shape the store used to have:
 * { wallet, wallet_name, connected, provider, signer, instance }
 */
export const useWallet = () => {
  const walletState = useSelector((state) => state.wallet);
  const { provider, signer, instance } = useWalletSession();
  return useMemo(() => ({ ...walletState, provider, signer, instance }), [walletState, provider, signer, instance]);
};
